import { useState } from "react";
import { InjectHTML } from "../html-inject";
import Modal from "react-modal";
import { IoMdClose } from "react-icons/io";

type ModalFilterProps = {
  stateModal: boolean;
  close?: () => void;
  embedCode: string;
};

export default function PreviewEmbedModal({embedCode,  stateModal, close }: ModalFilterProps) {

  return (
    <Modal
          isOpen={stateModal}
          onRequestClose={close}
          ariaHideApp={false}
          contentLabel="Selected Option"
          style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "#262626CC",
            zIndex: 1000,
          },
          content: {
            maxWidth: "1200px",
            maxHeight: "80vh",
            marginTop: "5%",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            zIndex: 1000,
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "20px",
            outline: "none",
            padding: "10px",
          },
        }}  
        >
          <div className="headerform" style={{ marginBottom: "20px" }}>
            <span style={{ color: "#1f3564", fontSize: "20px" }}>
             Pre-visualização do Embed code
            </span>
            <span
              style={{
                position: "absolute",
                right: "1%",
                top: "1%",
                fontSize: "16px",
                cursor: "pointer",
              }}
              onClick={close}
            >
              <IoMdClose />
            </span>
          </div>
        
            <div
              style={{
                flex: "1 1 auto",
                overflow: "auto",              
                paddingRight: "4px",   
              }}
            >
                <InjectHTML html={embedCode} />  
            </div>

        </Modal>
  );
}
